const r = ":host{display:inline-block;position:relative}.sl-tooltip__content{position:absolute;z-index:var(--sl-z-tooltip,1070);max-width:16rem;padding:0.375rem 0.625rem;background-color:hsl(var(--sl-hsl-foreground));color:hsl(var(--sl-hsl-background));border-radius:var(--sl-radius-sm);font-size:var(--sl-font-size-xs);font-family:var(--sl-font-family-base);line-height:1.4;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden;transition:opacity var(--sl-transition-fast) ease,visibility var(--sl-transition-fast) ease}.sl-tooltip__content--visible{opacity:1;visibility:visible}.sl-tooltip__content--top{bottom:calc(100% + 0.375rem);left:50%;transform:translateX(-50%)}.sl-tooltip__content--bottom{top:calc(100% + 0.375rem);left:50%;transform:translateX(-50%)}.sl-tooltip__content--left{right:calc(100% + 0.375rem);top:50%;transform:translateY(-50%)}.sl-tooltip__content--right{left:calc(100% + 0.375rem);top:50%;transform:translateY(-50%)}";
class l extends HTMLElement {
  constructor() {
    super(), this._visible = !1, this._delayTimer = null, this._shadow = this.attachShadow({ mode: "open" }), this._showBound = this._show.bind(this), this._hideBound = this._hide.bind(this), this._handleOutsideTouchBound = this._handleOutsideTouch.bind(this), this._render();
  }
  static get observedAttributes() {
    return ["content", "placement", "delay", "strategy"];
  }
  connectedCallback() {
    this.addEventListener("pointerenter", this._showBound), this.addEventListener("pointerleave", this._hideBound), this.addEventListener("focus", this._showBound, !0), this.addEventListener("blur", this._hideBound, !0), document.addEventListener("pointerdown", this._handleOutsideTouchBound);
  }
  disconnectedCallback() {
    this.removeEventListener("pointerenter", this._showBound), this.removeEventListener("pointerleave", this._hideBound), this.removeEventListener("focus", this._showBound, !0), this.removeEventListener("blur", this._hideBound, !0), document.removeEventListener("pointerdown", this._handleOutsideTouchBound), this._delayTimer !== null && clearTimeout(this._delayTimer);
  }
  attributeChangedCallback(t, e, i) {
    e !== i && this._render();
  }
  get content() {
    return this.getAttribute("content") || "";
  }
  set content(t) {
    this.setAttribute("content", t);
  }
  get placement() {
    return this.getAttribute("placement") || "top";
  }
  set placement(t) {
    this.setAttribute("placement", t);
  }
  get delay() {
    return parseInt(this.getAttribute("delay") || "200", 10);
  }
  set delay(t) {
    this.setAttribute("delay", String(t));
  }
  get strategy() {
    return this.getAttribute("strategy") || "absolute";
  }
  set strategy(t) {
    this.setAttribute("strategy", t);
  }
  _show() {
    this._delayTimer !== null && clearTimeout(this._delayTimer), this._delayTimer = setTimeout(() => {
      this._visible = !0, this._updateVisibility(), this._delayTimer = null;
    }, this.delay);
  }
  _hide() {
    this._delayTimer !== null && (clearTimeout(this._delayTimer), this._delayTimer = null), this._visible = !1, this._updateVisibility();
  }
  _updateVisibility() {
    const t = this._shadow.querySelector(".sl-tooltip__content");
    t && (t.classList.toggle("sl-tooltip__content--visible", this._visible), this._visible && this.strategy === "fixed" && this._positionFixed(t));
  }
  _handleOutsideTouch(t) {
    t.pointerType === "touch" && !this.contains(t.target) && this._hide();
  }
  _positionFixed(t) {
    const e = this.getBoundingClientRect(), i = 6, s = 8;
    switch (t.style.position = "fixed", t.style.margin = "0", t.style.top = "auto", t.style.bottom = "auto", t.style.left = "auto", t.style.right = "auto", t.style.transform = "none", this.placement) {
      case "top":
        t.style.bottom = `${window.innerHeight - e.top + i}px`, t.style.left = `${e.left + e.width / 2}px`, t.style.transform = "translateX(-50%)";
        break;
      case "bottom":
        t.style.top = `${e.bottom + i}px`, t.style.left = `${e.left + e.width / 2}px`, t.style.transform = "translateX(-50%)";
        break;
      case "left":
        t.style.top = `${e.top + e.height / 2}px`, t.style.right = `${window.innerWidth - e.left + i}px`, t.style.transform = "translateY(-50%)";
        break;
      case "right":
        t.style.top = `${e.top + e.height / 2}px`, t.style.left = `${e.right + i}px`, t.style.transform = "translateY(-50%)";
        break;
    }
    requestAnimationFrame(() => {
      const n = t.getBoundingClientRect();
      n.left < s ? (t.style.left = `${s}px`, t.style.right = "auto", t.style.transform = "none") : n.right > window.innerWidth - s && (t.style.left = "auto", t.style.right = `${s}px`, t.style.transform = "none"), n.top < s ? (t.style.top = `${s}px`, t.style.bottom = "auto", t.style.transform = "none") : n.bottom > window.innerHeight - s && (t.style.bottom = `${s}px`, t.style.top = "auto", t.style.transform = "none");
    });
  }
  _render() {
    const t = this._visible;
    this._shadow.innerHTML = `
      <style>${r}</style>
      <slot></slot>
      <div
        class="sl-tooltip__content sl-tooltip__content--${this.placement}"
        role="tooltip"
        id="sl-tooltip-content"
      >${this.content}</div>
    `, t && this._updateVisibility();
  }
}
typeof customElements < "u" && !customElements.get("sl-tooltip") && customElements.define("sl-tooltip", l);
export {
  l as SlTooltipElement
};
//# sourceMappingURL=sl-tooltip.js.map
